// @flow
import * as React from 'react';
import LoggedoutStore from '../../main/stores/LoggedoutStore';
import LoggedoutActions from '../../main/actions/LoggedoutActions';
import { BranchLoader } from '../../common/components/core';
import R from 'ramda';
import EmailVerificationStatusLayout from './EmailVerificationStatusLayout';
import * as queryString from 'query-string';
import type { HistoryType } from '../../common/router/withRouter';

// Body content strings
const SUCCESS_HEADER_TITLE = 'Email Verified!';
const SUCCESS_HEADER_SUBTITLE = 'Thanks for verifying!';
const SUCCESS_BODY_MESSAGE =
  "Hooray! We have verified your account and you're all set! You can now start using the Branch Dashboard.";
const SUCCESS_BUTTON_TITLE = 'Continue to Login';
const SUCCESS_IMAGE_URL =
  'https://res.cloudinary.com/dzeo8q4va/image/upload/v1577428920/img_verified.png';

const FAILURE_HEADER_TITLE = 'Email Verification Failed';
const FAILURE_HEADER_SUBTITLE = 'Something went wrong';
const FAILURE_BODY_MESSAGE =
  'We were unable to verify your account. Please try again later!';
const FAILURE_BUTTON_TITLE = 'Signup';
const FAILURE_IMAGE_URL =
  'https://res.cloudinary.com/dzeo8q4va/image/upload/v1577428920/img_linkExpired.png';

type Props = {
  location: {
    search: string
  },
  history: HistoryType
};

type State = {
  token: ?string,
  emailVerification: ?string,
  loading: ?boolean,
  verified: ?boolean,
  showError: ?boolean,
  errorMessage: ?string
};

class ScreenVerifyEmail extends React.Component<Props, State> {
  state = {
    token: queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true
    }).token,
    emailVerification: LoggedoutStore.verifyUser(
      queryString.parse(this.props.location.search, {
        ignoreQueryPrefix: true
      }).token
    ),
    loading: true,
    verified: false,
    showError: false,
    errorMessage: ''
  };

  componentDidMount() {
    LoggedoutActions.clearErrors();
    LoggedoutStore.addChangeListener(this._onChange);
  }

  componentWillUnmount() {
    LoggedoutStore.removeChangeListener(this._onChange);
  }

  _errorMessage = (errors: Object) => {
    const statusCode = R.path(['status'], errors);
    if (statusCode === 429) {
      return 'You have exceeded the amount of requests. Please try again after sometime.';
    } else if (statusCode === 500) {
      return 'Please try again after sometime.';
    } else if (statusCode === 409) {
      return 'This verification link is expired.';
    }
    return R.path(['statusText'], errors)
      ? errors.statusText
      : 'Please try again after sometime.';
  };

  _onChange = () => {
    const emailVerification = LoggedoutStore.verifyUser(this.state.token);
    const errors = LoggedoutStore.getErrors();
    const showError = errors.data ? true : false;
    const errorMessage = this._errorMessage(errors);
    this.setState(
      { emailVerification, showError, errorMessage },
      this._checkVerificationStatus
    );
  };

  _preventDefault = (ev: Object) => {
    ev.preventDefault();
  };

  _checkVerificationStatus = () => {
    if (
      this.state.emailVerification === 'EMAIL_VERIFICATION_IN_PROGRESS' &&
      this.state.showError === false
    ) {
      this.setState({ loading: true });
    } else if (
      this.state.emailVerification === 'EMAIL_VERIFICATION_SUCCESSFUL'
    ) {
      this.setState({ loading: false, verified: true });
    } else {
      this.setState({ loading: false, verified: false });
    }
  };

  _handlePrimaryClick = () => {
    if (this.state.verified) {
      this.props.history.push('/login');
    } else {
      this.props.history.push('/');
    }
  };

  _renderEmailStatusLayout = () => {
    const isVerified = this.state.verified ? true : false;
    const showError = this.state.showError ? true : false;
    const errorMessage = this.state.errorMessage
      ? this.state.errorMessage
      : 'Something went wrong';

    let title = FAILURE_HEADER_TITLE;
    let subTitle = FAILURE_HEADER_SUBTITLE;
    let message = FAILURE_BODY_MESSAGE;
    let buttonTitle = FAILURE_BUTTON_TITLE;
    let imageURL = FAILURE_IMAGE_URL;

    if (isVerified) {
      title = SUCCESS_HEADER_TITLE;
      subTitle = SUCCESS_HEADER_SUBTITLE;
      message = SUCCESS_BODY_MESSAGE;
      buttonTitle = SUCCESS_BUTTON_TITLE;
      imageURL = SUCCESS_IMAGE_URL;
    }

    return (
      <EmailVerificationStatusLayout
        onActionClick={this._handlePrimaryClick}
        headerTitle={title}
        headerSubtitle={subTitle}
        message={message}
        buttonTitle={buttonTitle}
        imageURL={imageURL}
        showError={showError}
        errorMessage={errorMessage}
      />
    );
  };

  render() {
    return (
      <div className="accept-invite-container">
        <div className="accept-invite-header">
          <img
            className="branch-logo"
            src="/static/images/branch-logos/branch-logo_dark.svg"
          />
        </div>
        {this.state.loading ? (
          <BranchLoader size="medium" />
        ) : (
          this._renderEmailStatusLayout()
        )}
      </div>
    );
  }
}

export default ScreenVerifyEmail;
